/**
 * Maximum length the backend accepts for the supplier invoice number on a
 * vehicle warehouse receipt. Mirrors the `maxLength` of the receive and
 * re-receive request bodies.
 */
export const SUPPLIER_INVOICE_NUMBER_MAX_LENGTH = 255;
